import { useEffect } from 'react';

const SITE = 'VotePlan';

/**
 * Sets document.title to "<title> | VotePlan".
 * Pass null/undefined to reset to the bare site name.
 */
export function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} | ${SITE}` : SITE;
  }, [title]);
}
